import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { FaRobot, FaUser } from "react-icons/fa";
import { css, spacing, typographyColors, uiColors } from "../library";
import { colors, styles } from "../library/theme";

// Sombra suave da bolha do usuário, derivada do accent (#e04942) da paleta.
const accentShadow = "rgba(224, 73, 66, 0.34)";

const row = css({
  display: "flex",
  gap: 11,
  alignItems: "flex-end",
  maxWidth: "100%",
});
const userRow = css({
  flexDirection: "row-reverse",
});
const avatar = css({
  flex: "0 0 30px",
  width: 30,
  height: 30,
  borderRadius: "50%",
  display: "grid",
  placeItems: "center",
  marginBottom: 2,
});
const botAvatar = css(avatar, {
  backgroundColor: uiColors.theme,
  color: colors.white,
});
const userAvatar = css(avatar, {
  backgroundColor: colors.greyLightest,
  border: `1px solid ${uiColors.border}`,
  color: typographyColors.defaultBody,
});
const bubble = css(styles.wrappingText, {
  padding: "12px 15px",
  borderRadius: 16,
  fontSize: 14,
  lineHeight: 1.6,
  maxWidth: "74%",
  "> *:last-child": { marginBottom: 0 },
  "ol, ul": { paddingLeft: 20, margin: `${spacing.xxs} 0 0` },
  p: { marginBottom: spacing.xs },
  strong: { fontWeight: 600, color: colors.greyDarker },
});
const botBubble = css(bubble, {
  backgroundColor: colors.greyLightest,
  color: typographyColors.defaultBody,
  borderBottomLeftRadius: 5,
});
const userBubble = css(bubble, {
  backgroundColor: uiColors.theme,
  color: colors.white,
  borderBottomRightRadius: 5,
  boxShadow: `0 2px 8px ${accentShadow}`,
  strong: { color: colors.white },
});

// Em streaming o texto chega cortado no meio dos marcadores: o serviço manda
// " **" num pedaço e o "**" de fechamento vários pedaços depois. Renderizado
// como está, o aluno veria os asteriscos crus até fechar. Fechamos os
// marcadores em aberto só para exibir, então o trecho já aparece formatado
// enquanto é digitado — e nada muda quando o fechamento real chega.
function closeOpenMarkers(text) {
  let preview = text;

  // Bloco de código primeiro: dentro dele os outros marcadores são literais.
  if ((preview.match(/```/g) || []).length % 2 === 1) {
    return `${preview}\n\`\`\``;
  }

  if ((preview.match(/\*\*/g) || []).length % 2 === 1) preview += "**";
  if ((preview.match(/(^|[^`])`([^`]|$)/g) || []).length % 2 === 1) preview += "`";

  return preview;
}

export default function ChatMessage({ message, streaming }) {
  const isUser = message.role === "user";
  const text = streaming ? closeOpenMarkers(message.text) : message.text;

  return (
    <div className={css(row, isUser && userRow)}>
      <div className={isUser ? userAvatar : botAvatar}>
        {isUser ? <FaUser size={13} /> : <FaRobot size={15} />}
      </div>
      <div className={isUser ? userBubble : botBubble}>
        {isUser ? (
          message.text
        ) : (
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
        )}
      </div>
    </div>
  );
}
